var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrying(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,92.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330 794 c-68 -31 -124 -84 -158 -149 -23 -43 -27 -62 -27 -140 0 -78 4 -97 27 -140 33 -63 88 -118 147 -147 62 -31 217 -33 271 -4 135 72 207 210 179 346 -16 75 -42 124 -96 176 -90 85 -232 110 -343 58z m175 5 c33 -6 72 -17 88 -25 49 -26 108 -86 135 -138 22 -43 27 -64 27 -131 0 -98 -28 -159 -104 -227 -189 -170 -494 -30 -494 227 0 150 107 272 263 298 14 2 25 5 26 6 0 0 27 -4 59 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 611 c0 -6 9 -11 20 -11 32 0 23 -14 -21 -32 -23 -10 -38 -22 -34 -28 4 -7 14 -5 28 5 12 8 38 15 59 15 42 0 47 9 21 33 -23 20 -73 33 -73 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563 605 c-45 -19 -44 -45 2 -45 20 0 47 -7 60 -16 14 -9 25 -12 25 -6 0 15 -41 42 -63 42 -10 0 -15 5 -12 10 3 6 15 10 26 10 11 0 17 5 14 10 -8 13 -13 12 -52 -5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373 480 c-31 -13 -43 -41 -43 -99 l0 -51 125 0 125 0 0 58 c0 81 -18 96 -113 99 -40 2 -82 -1 -94 -7z m168 -20 c36 -20 23 -40 -26 -40 -58 0 -111 -22 -120 -49 -3 -12 -15 -21 -26 -21 -16 0 -19 7 -19 42 0 63 19 78 102 78 38 0 78 -5 89 -10z m17 -87 c-3 -27 -4 -28 -73 -27 -38 1 -71 6 -73 12 -7 21 42 42 96 42 52 0 53 -1 50 -27z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrying);
export default __webpack_public_path__ + "static/media/crying.2207d2194f0c2b507d9cbec33fb9fc5b.svg";
export { ForwardRef as ReactComponent };